import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, roles }) => {
  const token = localStorage.getItem("token");

  // Role get karo
  let role = localStorage.getItem("role");
  let permissions = [];
  if (!role) {
    const user = JSON.parse(localStorage.getItem("user"));
    role = user?.role;
  }
  try {
    permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch (e) {
    permissions = [];
  }
  if (!Array.isArray(permissions) || permissions.length === 0) {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      permissions = Array.isArray(user?.permissions) ? user.permissions : [];
    } catch (e) {
      permissions = [];
    }
  }

  // ✅ Token missing → login par bhejo
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Role mismatch → uske apne dashboard par bhejo
  const hasGuardAccess =
    (role === "employee" || role === "guard") &&
    (permissions.includes("guard:access") ||
      permissions.some((p) => typeof p === "string" && p.startsWith("security:")));
  const hasEmployeePanelAccess = role === "employee" || role === "guard";
  const roleMatches = roles
    ? roles.includes(role) ||
      (roles.includes("guard") && hasGuardAccess) ||
      (roles.includes("employee") && hasEmployeePanelAccess)
    : true;

  if (!roleMatches) {
    if (role === "admin") return <Navigate to="/admin" replace />;
    if (role === "vendor") return <Navigate to="/vendor" replace />;
    if (role === "supplier") return <Navigate to="/supplier" replace />;
    if (role === "contractor") return <Navigate to="/contractor" replace />;
    if (role === "government") return <Navigate to="/government" replace />;
    if (role === "employee") return <Navigate to="/employee" replace />;
    if (role === "guard") return <Navigate to="/employee/guard/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
